import { DB_Item, OntologyDictionary } from "src/models/general-models";
import { API_EndPoints, ExecuteAPI_Select } from "./onit-server-utils";
import { getString } from "../graphDB-utils";
import StorageUtils from "./storage-utils";
import * as QueryString from "query-string"

export function redirectBackToApp(instance: string) {
    let redirectURL = fetchRedirectURL();

    if (!redirectURL || redirectURL.indexOf("#") == -1) {
        if (location.href.toLowerCase().indexOf("localhost") !== -1) {
            redirectURL = "http://localhost:3000/#" + instance;
        }
        else if (location.href.toLowerCase().indexOf("dev") !== -1) {
            redirectURL = "https://devapp.onitnetwork.com/#" + instance;
        }
        else {
            redirectURL = "https://app.onitnetwork.com/#" + instance;
        }
    }
    location.href = redirectURL;
}

export function fetchRedirectURL() {
    let redirectURL = "";

    if (location.search && QueryString) {
        let queryParams: any = QueryString.parse(location.search);
        if (queryParams.returnURL) {
            redirectURL = decodeURIComponent(queryParams.returnURL);
        }
    }
    if (!redirectURL && location.hash.indexOf('?') && QueryString) {
        let queryParams: any = QueryString.parse(location.hash.substr(location.hash.indexOf('?')));
        if (queryParams.returnURL) {
            redirectURL = decodeURIComponent(queryParams.returnURL);
        }
    }
    return redirectURL;
}

export function CelsiusToFahrenheit(celsius: number) {
    if (celsius)
        return celsius * 9 / 5 + 32;
    else
        return 0;
}

export function FahrenheitToCelsius(fahrenheit: number) {
    if (fahrenheit)
        return (fahrenheit - 32) * 5 / 9;
    else
        return
    0
}

// replace spaces only for User, tenants and ProductLink
export function replaceSpaces(str: string): string {
    let res = ""
    if (str && str.length > 0)
        res = str.trim().replace(new RegExp(" ", 'g'), "_");
    else
        res = "";

    if (res == "undefined") {
        return ""
    }
    return res;
}

export function replaceSpacesAndSlashes(str: string): string {
    let res = ""
    if (str && str.length > 0)
        res = str.trim().replace(new RegExp(" ", 'g'), "_").replace(new RegExp("/", 'g'), "-");
    else
        res = "";

    if (res == "undefined") {
        return ""
    }
    return res;
}

export async function isOntologyExist(entityName: string, typeName?: Array<string>) {
    return await ExecuteAPI_Select<unknown>({ entityName, typeName }, API_EndPoints.IsOntologyExist)
}

export async function getSubClassOf(className: string, entity: string) {
    return await ExecuteAPI_Select<DB_Item[]>({ className }, API_EndPoints.GetSubClassOf, entity)
}

export async function getRdfsLabel(ontology: string) {
    const res = await ExecuteAPI_Select<DB_Item[]>({ ontology }, API_EndPoints.GetRdfsLabel, "")
    return res && res.length && res[0] && getString(res[0]) ? getString(res[0]) : ontology;
}

export function GetValidPhoneNumber(_pNumber: string): string {
    let res: string[] = [];
    let pn = _pNumber.split(",");
    for (let index = 0; index < pn.length; index++) {
        const _phoneNumber = pn[index];

        let phoneNumber = _phoneNumber.replace("+1", "").replace(new RegExp(" ", 'g'), "").
            replace(new RegExp("-", 'g'), "").replace(/\(/gi, "").replace(/\)/gi, "");
        res.push(`+1${phoneNumber}`);
    }

    return res.join(",");
}

export function bin2String(bArr): string {
    return String.fromCharCode.apply(String, bArr);
}

export function getParameterByName(name: string, url?: string) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getRandomString(length: number) {
    let text = "";
    let possible = "abcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
}

export function getRandomNumber(numberOfDigits: number) {
    return Math.floor(Math.pow(10, numberOfDigits - 1) + Math.random() * 9 * Math.pow(10, numberOfDigits - 1));
}

export function getDateDiffInDays(date1: Date, date2: Date) {
    const diff = Math.abs(date1.getTime() - date2.getTime());
    return Math.ceil(diff / (1000 * 3600 * 24));
}

export function getDateDiffInHours(date1: Date, date2: Date) {
    const diff = Math.abs(date1.getTime() - date2.getTime());
    return Math.ceil(diff / (1000 * 60 * 60));
}

export function getDateDiffInMinutes(date1: Date, date2: Date) {
    const diff = Math.abs(date1.getTime() - date2.getTime());
    return Math.ceil(diff / (1000 * 60));
}

export function setOntologyDictionaryItem(ontology: string, rdfsLabel: string) {
    let ontologyDictionary: OntologyDictionary[] = JSON.parse(StorageUtils.getItem("OntologyDictionary"));
    if (!ontologyDictionary) {
        ontologyDictionary = [];
    }
    const itemIndex = ontologyDictionary.findIndex(x => x.ontology == ontology);
    if (itemIndex == -1) {
        ontologyDictionary.push({ ontology, rdfsLabel });
    } else {
        ontologyDictionary[itemIndex].ontology = ontology;
        ontologyDictionary[itemIndex].rdfsLabel = rdfsLabel;
    }
    StorageUtils.setItem("OntologyDictionary", JSON.stringify(ontologyDictionary))
}

export function getOntologyDictionaryItem(ontology: string): string {
    let ontologyDictionary: OntologyDictionary[] = JSON.parse(StorageUtils.getItem("OntologyDictionary"));
    if (!ontologyDictionary) {
        ontologyDictionary = [];
    }
    const item = ontologyDictionary.find(x => x.ontology == ontology);
    let result = item && item.rdfsLabel ? item.rdfsLabel : ontology;
    if (result != ontology) {
        return result;
    } else {
        if (ontology.indexOf(" ") == -1) {
            getRdfsLabel(ontology).then(res => {
                if (res != ontology) {
                    setOntologyDictionaryItem(ontology, res);
                    result = res;
                }
            })
        }
        return result;
    }
    // return item && item.rdfsLabel ? item.rdfsLabel : ontology;
}

export function IsNavigationAllowed(url: string): void {
    if (!checkHashURL()) {
        window.location.hash = url;
    } else {
        StorageUtils.setItem("urlToRedirect", url);

        document.getElementById("btnPrevent").click();

    }
}

function checkHashURL(): boolean {
    const formsList = ["new", "create", "form", "edit"];
    for (let index = 0; index < formsList.length; index++) {
        const item = formsList[index].toLowerCase();

        if (window.location.hash.toLowerCase().indexOf(item) != -1) {
            return true;
        }
    }
    return false;
}


export function isSMSAllowed(scheduleString: string): boolean {
    let now = new Date();
    let isAllowed: boolean = false;
    if (scheduleString != "") {
        let splitSchedule = scheduleString.split("-");
        let startTime = new Date();
        startTime.setHours(parseInt(splitSchedule[0]));
        startTime.setMinutes(0);
        let endTime = new Date();
        endTime.setHours(parseInt(splitSchedule[1]));
        endTime.setMinutes(0);
        if (now > startTime && now < endTime)
            isAllowed = true;
        else
            isAllowed = false;
    }
    return isAllowed
}




// WEBPACK FOOTER //
// ./src/server/utils/general-utils.ts